const ubicacionInitialState = {
    ubicacion : {
        data: null, 
        loading: false, 
        error: false 
    }
}

export default ubicacionInitialState; 